/*
 * @Author: wutt
 * @Date: 2020-11-17 15:22:00
 * @LastEditors: wutt
 * @LastEditTime: 2020-11-21 18:28:01
 * @Description: 
 * @FilePath: /DianZiDiTu/src/components/onlineMap/mainMap/layer/MapBaseLayerEx.js
 */
/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-10-14 10:20:38
 * @LastEditTime: 2019-10-14 10:20:55
 * @LastEditors: Please set LastEditors
 */
import { BaseLayerConfig } from "../../../../config/BaseLayerConfig.js";
import { ServiceUrlConfig } from "../../../../config/ServiceUrlConfigJs.js";
import { OLLayerUtility } from "../../../../utility/common/OLLayerUtility.js";
import { OLSourceType } from "../../model/DataSource/OLSourceTypeJs.js";
import { TDTServiceInfoFilter, TDTServiceInfoFilterResult, TDTServiceInfos } from "../../model/TDTServiceInfoJs.js";


/**
 * 地图底图
 */
export class MapBaseLayerEx {

    constructor() {
        this.curMap = null;
        this.tdtServiceInfos = new TDTServiceInfos();
    }
    init(callback) {
        let self = this;
        console.log('走底图配置');
        // this.tdtServiceInfos = TDTServiceInfos.mockXYZData();
        // this.tdtServiceInfos.createLayers();
        // if (callback) {
        //     callback();
        // }
        let filter = new TDTServiceInfoFilter();
        filter.useServiceFormat = true;
        filter.serviceFormat = OLSourceType.source_xyz;
        filter.useSourceFilters = true;
        let selectByFilterUrl =  ServiceUrlConfig.platform_baseLayerConfig_selectByFilter;
       TDTServiceInfos.selectByFilter(
           filter,
           selectByFilterUrl,
           function (response) {
               let filterResult = TDTServiceInfoFilterResult.parseJson(response);   
               self.tdtServiceInfos  = filterResult.tdtServiceInfos;
               self.tdtServiceInfos.createLayers();
               if (callback) {
                   callback();
               }
           },function(){
               console.log('无法获取底图配置信息！');             
           })  
      
    }
    /**
     * 展示可见图层
     * @param {*} baseLayerType  底图类型
     */
    /**
     * 展示可见图层
     * @param {*} baseLayerType  底图类型
     */
    showVisibleLayer(baseLayerType) {
        let layers = this.curMap.getLayers();

        if (baseLayerType === MapBaseLayerType.Image) {
            let tdtServiceInfosObj = this.tdtServiceInfos.findByType(MapBaseLayerType.Image);
            let tdtServiceInfo = null;
            for (let i = 0; i < tdtServiceInfosObj.length; i++) {
                tdtServiceInfo = tdtServiceInfosObj[i];
                let imgLayer = this.findBaseLayer(tdtServiceInfo.serviceSource.params_value_layer);
                if (!imgLayer) { 
                    imgLayer = tdtServiceInfo.olLayer;
                    if(imgLayer){
                        imgLayer.onAdd = function (map) { };
                        layers.insertAt(layers.getArray().length, imgLayer);
                    }               
                }
                else {
                    imgLayer.setVisible(true);
                }
            }
            this.hiddenLayer(MapBaseLayerType.Vector);
            this.hiddenLayer(MapBaseLayerType.Ter);
        }
        else if (baseLayerType === MapBaseLayerType.Vector) {
            let tdtServiceInfosObj = this.tdtServiceInfos.findByType(MapBaseLayerType.Vector);
            let tdtServiceInfo = null;
            for (let i = 0; i < tdtServiceInfosObj.length; i++) {
                tdtServiceInfo = tdtServiceInfosObj[i];
                let vecLayer = this.findBaseLayer(tdtServiceInfo.serviceSource.params_value_layer);
                if (!vecLayer) {
                    vecLayer = tdtServiceInfo.olLayer;
                    if(vecLayer){
                        vecLayer.onAdd = function (map) { };
                        layers.insertAt(layers.getArray().length, vecLayer);
                    }              
                }
                else {
                    vecLayer.setVisible(true);
                }
            }
            this.hiddenLayer(MapBaseLayerType.Image);
            this.hiddenLayer(MapBaseLayerType.Ter);
        }
        else if (baseLayerType === MapBaseLayerType.Ter) {

            let tdtServiceInfosObj = this.tdtServiceInfos.findByType(MapBaseLayerType.Ter);
            let tdtServiceInfo = null;
            for (let i = 0; i < tdtServiceInfosObj.length; i++) {
                tdtServiceInfo = tdtServiceInfosObj[i];
                let terLayer = this.findBaseLayer(tdtServiceInfo.serviceSource.params_value_layer);
                if (!terLayer) {                         
                    terLayer = tdtServiceInfo.olLayer;
                    if(terLayer){
                        terLayer.onAdd = function (map) { };
                        layers.insertAt(layers.getArray().length, terLayer);
                    }                
                }
                else {
                    terLayer.setVisible(true);
                }
            }
            this.hiddenLayer(MapBaseLayerType.Image);
            this.hiddenLayer(MapBaseLayerType.Vector);
        }

    }

    findBaseLayer(layerName) {
        let findLayer = null;
        let layers = this.curMap.getLayers().getArray();

        let allLayers = OLLayerUtility.getLayers(layers);


        let tempLayer = null;
        let tempName = null;

        for (let tempIndex = 0; tempIndex < allLayers.length; tempIndex++) {

            tempLayer = allLayers[tempIndex];

            tempName = tempLayer.get(BaseLayerConfig.key_layer_name);
            if (tempName) {
                if ( tempName === layerName) {
                    findLayer = tempLayer;
                    break;
                }
            }
        }

        return findLayer;
    }


    /**
     * 隐藏图层
     * @param {*} layerType 
     */
    hiddenLayer(layerType) {

        let layers = this.curMap.getLayers().getArray();

        let allLayers = OLLayerUtility.getLayers(layers);


        let tempLayer = null;
        let tempLayerName = null;
        let tempInfo = null;

        for (let tempIndex = 0; tempIndex < allLayers.length; tempIndex++) {
            tempLayer = allLayers[tempIndex];
            tempLayerName = tempLayer.get(BaseLayerConfig.key_layer_name);
            if (tempLayerName) {
                    let allToHideInfos = this.tdtServiceInfos.findByType(layerType)
                    for (let index = 0; index < allToHideInfos.length; index++) {
                        tempInfo = allToHideInfos[index];                     
                        if ( tempInfo.serviceSource.params_value_layer== tempLayerName) {
                            tempLayer.setVisible(false);
                        }
                    }
            }
        }
    }
   
}

export const MapBaseLayerType =
{

    Vector: "Vector",

    Image: "Image",

    Ter: "Ter",



}


